<template>
  <div class="rings">
    <div class="ring-outer">
      <ProgressRing :size="320" :width="25" :value="outerVal" :label="label" :labelColor="innerColor" color="#FFFFFFAA"/>
    </div>
    <div class="ring-inner">
      <ProgressRing :size="250" :width="25" :value="innerVal" :color="innerColor"/>
    </div>
    <div class="label">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue'

import ProgressRing from '../components/ProgressRing.vue'

const props = defineProps<{
  innerVal: number,
  outerVal: number,
  isWork: boolean,
  label?: string
}>()

const innerColor = computed(() => '#FFFFFFAA') // props.isWork ? '#FF3344' : '#7799FF')
</script>

<style scoped lang="scss">
  .rings {
    position: relative;
    width: 80vw;
    height: 80vw;
    margin-left: 10vw;

    div {
      position: absolute;
      width: 100%;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ring-outer {
      position: absolute;
      z-index: 2
    }

    .ring-inner {
      position: absolute;
      z-index: 3
    }

    .label {
      font-size: 3rem;
      position: absolute;
    }
  }
</style>
